import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {Router} from '@angular/router';
import {ApiConstants, CustomHttp} from '../../shared';
import * as _ from 'lodash';
import {DomSanitizer} from '@angular/platform-browser';
import {DatePipe} from '@angular/common';


@Injectable()
export class BulkInfohashV2Service {
    private META_DATA_URL = 'metadata/tv?key=gx4tG2hALXWgQt7o4YTU&query=';
    private META_DATA_ENTENDED_URL = '&extended=true&internal=true&images=true';
    private CONTENT_TYPE_ENTENDED_URL = '&specifiedContentType=';
    private MISSING_IMAGES_URL = 'catalog/tv?sortby=start_date&orderby=asc&images=true&images_missing=true';
    private ALL_CATALOG_URL = 'catalog/tv?internal=true&images=true';
    private GENOME_UPDATE_URL = 'genes_update';
    private GENOME_NOTE_URL = 'enrich/note';
    private WIKI_URL = 'wikipedia?fullRefresh=true';
    private DAILY_INFOHASH_CHECK_URL = 'daily_title_infohash_check';
    private DATAHEALTH_MAPPINGS_URL = 'datahealth';
    private TITLE_NAME_CHANGE_URL = 'enrich/updatetitles/tv';
    private META_DATA_CONTENT_TYPE_URL = 'metadata/';
    private QUERY_PARAM = '?key=gx4tG2hALXWgQt7o4YTU&query=';
    private INFOHASH_SEARCH = '/cumulative_torrents/v2/datahealth/';

    private ES_GLOBAL_QUERY = {
        'id': '',
        'params': {
            'search_str': '',
            'min_terms': ''
        }
    };

    private ES_LOADMETADATA_QUERY = {
        'query': {
            'bool': {
                'should': [
                    {
                        'match': {
                            'data.external_mappings.wiki_id': ''
                        }

                    },
                    {
                        'match': {
                            'data.external_mappings.imdb_id': ''
                        }

                    },
                    {
                        'match': {
                            'data.external_mappings.wikibase_id': ''
                        }

                    }
                ]
            }
        }
    };


    private ES_GET_EXTRA_QUERY_FIELDS = {
        'query': {
            'bool': {
                'must': [
                    {
                        'term': {
                            'parrot_id': ''
                        }
                    }
                ]
            }
        }
    };

    private ES_QUERY_OBJECT = {
        'query': {
            'bool': {
                'must': [
                    {
                        'multi_match': {
                            'query': '',
                            'type': 'best_fields',
                            'fields': [
                                'title',
                                'display_name',
                                'parrot_id',
                                'data.also_known_as^1.3',
                                'data.external_mappings.*',
                                'extended.tms.tms_id',
                                'extended.wiki.wikibase_id',
                                'extended.wiki.langlinks.title',
                                'extended.wiki.langlinks.url',
                                'extended.wiki.title',
                            ],
                            'minimum_should_match': 1,
                            'fuzziness': 0.5,
                            'prefix_length': 3,
                            'slop': 3
                        }
                    }
                ]
            }
        },
        'timeout': '7s',
        '_source': [],
        'size': 15
    };
    private ES_IMDB_QUERY_OBJECT = {
        'query': {
            'bool': {
                'must': [
                    {
                        'multi_match': {
                            'query': '',
                            'type': 'best_fields',
                            'fields': [
                                'Title',
                                'AKAs.AKA.Title'
                            ],
                            'minimum_should_match': 1,
                            'fuzziness': 1,
                            'prefix_length': 3,
                            'slop': 3
                        }
                    }
                ]
            }
        },
        'timeout': '7s',
        '_source': [],
        'size': 15
    };
    private ES_DEFAULT_SOURCE = [
        'title', 'parrot_id', 'display_name', 'catalog_state', 'internal_data',
        'data.release_year', 'data.type', 'data.original_country', 'data.original_network',
        'data.original_language', 'data.short_description', 'data.also_known_as',
        'data.external_mappings', 'data.genre_tags', 'data.total_seasons', 'data.total_episodes'
    ];
    private ES_SORT_BY_PRIORITY = {
        '_script': {
            'type': 'number',
            'script': {
                'lang': 'painless',
                'source': 'if (doc.containsKey(\'internal_data.priority.keyword\') && !doc[\'internal_data.priority.keyword\'].empty) ' +
                    '{if (doc[\'internal_data.priority.keyword\'].value.toLowerCase() == \'high\') {return 3;} ' +
                    'else if (doc[\'internal_data.priority.keyword\'].value.toLowerCase() == \'medium\') {return 2;}' +
                    'else if (doc[\'internal_data.priority.keyword\'].value.toLowerCase() == \'low\') {return 1;} else {return 0;}} else {return 0;}'
            },
            'order': 'desc'
        }
    };

    constructor(private datePipe: DatePipe, private router: Router, private http: Http,
                private ApiConstants: ApiConstants, private customHttp: CustomHttp, private sanitizer: DomSanitizer) {
    }


    getHelpdeskBaseUrl() {
        return this.ApiConstants.HELPDESK_API_URL;
    }

    getBaseUrl() {
        return this.ApiConstants.CATALOG_API_URL;
    }

    getBaseESIndex() {
        return this.ApiConstants.ES_SERVICE;
    }

    getESProxyUrl(index: string) {
        const baseURL = this.getBaseUrl().replace('catalogapi', 'helpdeskapi');
        return `${baseURL.replace('/v1', '')}proxy?service=${this.getBaseESIndex()}&uri=/${index}/_search`;
    }

    getGlobalESProxyUrl(index: string, template: string) {
        const baseURL = this.getBaseUrl().replace('catalogapi', 'helpdeskapi');
        return `${baseURL.replace('/v1', '')}proxy?service=${this.getBaseESIndex()}&uri=/${index}/_search/${template}`;
    }


    getEsDefaultSource() {
        return _.cloneDeep(this.ES_DEFAULT_SOURCE);
    }

    getEsQueryObject() {
        return _.cloneDeep(this.ES_QUERY_OBJECT);
    }

    getEsImdbQueryObject() {
        return _.cloneDeep(this.ES_IMDB_QUERY_OBJECT);
    }

    getESPrioritySortObject() {
        return _.cloneDeep(this.ES_SORT_BY_PRIORITY);
    }

    getCatalogMetadata(query: string, content_type) {
        const url = `${this.getBaseUrl()}${this.META_DATA_CONTENT_TYPE_URL}${content_type}` + `${this.QUERY_PARAM}${query}` + this.META_DATA_ENTENDED_URL;

        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => error);
    }

    getCatalog(query: string) {
        const url = `${this.getBaseUrl()}${this.META_DATA_URL}${query}` + this.META_DATA_ENTENDED_URL;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => error);
    }

    getCatalogByContentType(query: string, contentType) {
        let url = `${this.getBaseUrl()}${this.META_DATA_URL}${query}` + this.META_DATA_ENTENDED_URL;
        url = url.replace('/tv?', '/' + contentType + '?');

        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => error);
    }

    getCatalogMissingImages() {
        const url = this.getBaseUrl() + this.MISSING_IMAGES_URL;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }


    refreshWiki() {
        const url = this.getBaseUrl() + this.WIKI_URL; // `https://catalogapi.parrotanalytics.com/v1/catalog/tv`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => error);
    }

    getAllCatalogue() {
        const url = this.getBaseUrl() + this.ALL_CATALOG_URL; // `https://catalogapi.parrotanalytics.com/v1/catalog/tv`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    createAuthorizationHeader(headers: Headers) {
        headers.append('x-auth-token', localStorage.getItem('id_token'));
        headers.append('Content-Type', 'application/json');
        return headers;
    }

    updateGenome(selectedTitles: Array<string>, gene: Array<string>, values: Array<string>, contentType) {
        return new Promise((resolve, reject) => {
            const updateGenesList = selectedTitles.map((parrotId, index) => {
                return {
                    'parrot_id': parrotId,
                    'gene': gene[index],
                    'source': 'manual',
                    'value': values[index]
                };
            });
            const genomePayload = updateGenesList;
            this._updateGenome(genomePayload, contentType)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    console.error('Error trying to update the data state genome to customer ready: ' +
                        err.toString());
                    reject(err);
                });
        });
    }

    updateGenomeDeprecated(payload, contentType) {
        payload = payload['updateGenesList'];
        return this._updateGenome(payload, contentType);
    }

    private _updateGenome(payload, contentType) {
        // Hacky method to avoid having to move and change everything.
        const user = localStorage.getItem('userName');
        const uri = '/' + this.GENOME_UPDATE_URL + '?user=' + user + '&content_type=' + contentType;

        return this.customHttp.post(uri, JSON.stringify(payload));
    }

    updateNotes(payload, operation?) {
        let url = this.getBaseUrl() + this.GENOME_NOTE_URL;
        if (operation) {
            url += '/' + operation;
        }
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, JSON.stringify(payload), options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    getInfohashesBySearchQuery(payload) {
        let baseUrl = this.getHelpdeskBaseUrl();
        baseUrl = baseUrl.replace('/v1/', '/');
        const url = baseUrl + this.INFOHASH_SEARCH + 'cumulative_torrents';
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, payload, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    getSmartGroupedInfohash(payload, parrotId) {
        let baseUrl = this.getHelpdeskBaseUrl();
        baseUrl = baseUrl.replace('/v1/', '/');
        const url = baseUrl + this.INFOHASH_SEARCH + 'torrent_search?parrot_id=' + parrotId;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, payload, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    updateInfohashesh(payload) {
        let baseUrl = this.getHelpdeskBaseUrl();
        baseUrl = baseUrl.replace('/v1/', '/');
        const url = baseUrl + this.INFOHASH_SEARCH + 'update_torrents';
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, payload, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    addToCatalogGapTable(payload) {
        let baseUrl = this.getHelpdeskBaseUrl();
        baseUrl = baseUrl.replace('/v1/', '/');
        const url = baseUrl + '/cumulative_torrents/v2/audit';
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, payload, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    getSearchedTorrents(queryTerm, category) {

        let baseUrl = this.getHelpdeskBaseUrl();
        baseUrl = baseUrl.replace('/v1/', '/');
        const url = baseUrl + this.INFOHASH_SEARCH + 'torrent_search?term=' + queryTerm + '&category=' + category.toUpperCase();
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    getDailyTorrentsStats() {

        let baseUrl = this.getHelpdeskBaseUrl();
        baseUrl = baseUrl.replace('/v1/', '/');
        const url = baseUrl + '/cumulative_torrents/v2/stats/monthly';
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    getAllInfohashTorrentsStats() {

        let baseUrl = this.getHelpdeskBaseUrl();
        baseUrl = baseUrl.replace('/v1/', '/');
        const url = baseUrl + '/cumulative_torrents/v2/stats/historic';
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    getSmartGroupedTorrents(parrotID) {

        // /entity/cb26aa53-b0f1-4ba6-a319-7d95dc630ec9/video?confidence_label=low&page=1&size=100&sort=total_number_of_views&sort_direction=ASC
        // tslint:disable-next-line:max-line-length
        let baseUrl = this.getHelpdeskBaseUrl();
        baseUrl = baseUrl.replace('/v1/', '/');
        const url = baseUrl + this.INFOHASH_SEARCH + 'smart_grouping/' + parrotID;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.get(url, options)
            .map(res => res.json())
            .toPromise();
    }

    createCatalogTypeFilters(typeFilters: string[] = []) {
        return typeFilters.map((filter) => {
            return {
                'term': {
                    'data.type': filter
                }
            };
        });
    }

    createImdbTypeFilters(typeFilters: string[] = []) {
        return typeFilters.map((filter) => {
            return {
                'match_phrase': {
                    'TitleType': {
                        'query': filter
                    }
                }
            };
        });
    }

    createMultiMatchObject(matchType: string, fields: string[], query: string,
                           additionalItems?: { [s: string]: string; }) {
        return {
            'multi_match': {
                'query': query,
                'type': matchType,
                'fields': fields,
                ...additionalItems
            }
        };
    }

    createExtendedMultiMatchObject(matchType: string, fields: string[], query: string,
                                   additionalItems?: { [s: string]: string; }) {
        return {
            'multi_match': {
                'query': query,
                'type': matchType,
                'fields': fields,
                ...additionalItems
            }
        };
    }

    // tslint:disable-next-line:one-line
    createGlobalSearchEsQuery(title: string, words: any, searchIndex: string) {
        const request = _.cloneDeep(this.ES_GLOBAL_QUERY);
        request.params.search_str = title;
        request.params.min_terms = words;
        request.id = searchIndex;

        // console.log(JSON.stringify(request));
        return JSON.stringify(request);
    }

    callEsProxyCustomQuery(query: string, index = 'series_metadata') {
        const url = this.getESProxyUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callEsProxyLoadMetaData(query: string, index) {
        const url = this.getESProxyUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callEsProxyCustomQueryNewMetadata(query: string, index) {
        const url = this.getESProxyUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callEsProxybasedOnParrotIDQuery(query: string, index = 'master_tv_catalog') {
        const url = this.getESProxyUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callGlobalSearchEsProxyCustomQuery(query: string, index = 'series_metadata', template: string) {
        const url = this.getGlobalESProxyUrl(index, template);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callEsProxySeriesMetadataQuery(query: string, index = 'series_metadata') {
        const url = this.getESProxyUrl(index);
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, query, options)
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    callEsProxyForParrotIds(parrotIds: string[], source: string[] = ['parrot_id', 'title']) {
        const parrotIdMatchArray = parrotIds.map((parrotId) => {
            return {
                match: {
                    parrot_id: parrotId
                }
            };
        });
        const elasticSearchQuery = {
            'query': {
                'bool': {
                    'must': {
                        'bool': {
                            'should': parrotIdMatchArray
                        }
                    }
                }
            },
            '_source': source,
            'size': parrotIdMatchArray.length,
        };
        // console.log(JSON.stringify(elasticSearchQuery));
        return this.callEsProxyCustomQuery(JSON.stringify(elasticSearchQuery));
    }

    callEsProxyForParrotIdsUsingIndex(parrotIds: string[], source: string[] = ['parrot_id', 'title'], index) {
        const parrotIdMatchArray = parrotIds.map((parrotId) => {
            return {
                match: {
                    parrot_id: parrotId
                }
            };
        });
        const elasticSearchQuery = {
            'query': {
                'bool': {
                    'must': {
                        'bool': {
                            'should': parrotIdMatchArray
                        }
                    }
                }
            },
            '_source': source,
            'size': parrotIdMatchArray.length,
        };
        // console.log(JSON.stringify(elasticSearchQuery));
        return this.callEsProxyCustomQuery(JSON.stringify(elasticSearchQuery), index);
    }

    checkIfPresentInDailyInfohashes(parrotId: string) {
        const url = this.getBaseUrl() + this.DAILY_INFOHASH_CHECK_URL + '?parrotId=' + parrotId;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.get(url, options)
            .map(res => res.json())
            .toPromise();
    }

    addToDailyInfohashes(parrotId: string) {
        const url = this.getBaseUrl() + this.DAILY_INFOHASH_CHECK_URL + '/add?parrotId=' + parrotId;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, {}, options)
            .map(res => res.json())
            .toPromise();
    }

    removeFromDailyInfohashes(parrotId: string) {
        const url = this.getBaseUrl() + this.DAILY_INFOHASH_CHECK_URL + '/remove?parrotId=' + parrotId;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.post(url, {}, options)
            .map(res => res.json())
            .toPromise();
    }

    mapGlobalSearchEsResultItem(item) {

        return {
            title: item._source.title,
            displayName: item.highlight ? item.highlight.display_name[0] : item._source.display_name,
            displayNameTitle: item._source.display_name ? item._source.display_name : '',
            releaseYear: item._source.data ? item._source.data.release_year : '',
            parrotId: item._source.parrot_id,
            catalogType: item._source ? item._source.catalog_type : '',
            catalogState: item._source ? item._source.catalog_state : '',
            originalNetwork: item._source.data.original_network ? item._source.data.original_network['1'] : '',
            originalCountry: item._source.data.original_country ? item._source.data.original_country['1'] : ''

        };
    }


    infohashResultItem(item) {
        // console.log(item);
        return {
            catalog_state: item.catalog_state ? item.catalog_state : undefined,
            human_verified: item.human_verified ? item.human_verified : undefined,
            catalog_type: item.catalog_type ? item.catalog_type : '',
            displayName: item.displayName ? item.displayName : '',
            original_network: item.networks ? item.networks : '',
            original_country: item.countries ? item.countries : '',
            original_language: item.originalLanguage ? item.originalLanguage : '',

            infohash: item.infohash ? item.infohash : '',
            torrent_name: item.torrent_name ? item.torrent_name : '',
            category: item.category ? item.category : '',
            parrot_id: item.parrot_id ? item.parrot_id : '',

            title: item.title ? item.title : '',
            season: item.season ? item.season : '',
            episode: item.episode ? item.episode : '',
            hygiene_title: item.hygiene_title ? item.hygiene_title : '',
            seeders_leechers: item.seeders_leechers ? item.seeders_leechers : '',
            cumulative_total_records: item.cumulative_total_records ? item.cumulative_total_records : '',
            title_priority: item.title_priority ? item.title_priority : '',
            torrent_priority: item.torrent_priority ? item.torrent_priority : '',
            torrent_available: item.torrent_available ? item.torrent_available : '',
            release_year: item.startDate ? new Date(item.startDate).toISOString().slice(0, 10) : '',

            last_allocated_time: item.last_allocated_time ? new Date(item.last_allocated_time).toISOString().slice(0, 10) : '',
            discovery_time: item.discovery_time ? new Date(item.discovery_time).toISOString().slice(0, 10) : '',
            updated_time: item.updated_time ? new Date(item.updated_time).toISOString().slice(0, 10) : '',
            last_searched_time: item.last_searched_time ? new Date(item.last_searched_time).toISOString().slice(0, 10) : '',
            tracked_on: item.tracked_on ? new Date(item.tracked_on).toISOString().slice(0, 10) : ''
        };
    }


    infohashStatsItem(item) {
        // console.log(item);
        return {
            category: item.category,
            discovery_time: item.discovery_time ? new Date(item.discovery_time).toISOString().slice(0, 10) : '',
            total_torrents: item.total_torrents,
            pending_torrents: item.unverified
        };
    }

    allInfohashStatsItem(item) {
        return {
            category: item.category,
            discovery_time: item.date_year + '-' + ((item.date_month) < 10 ? '0' + item.date_month : item.date_month ),
            total_torrents: item.total_torrents,
            pending_torrents: item.unverified
        };
    }


    private getConfidenceBreakdwon(confidence_breakdown: any) {
        let confidenceBreakdown = [];
        confidenceBreakdown = confidenceBreakdown.concat(confidence_breakdown.map(item => this.mapConfidenceLevel(item)));

        let lowCount = 0;
        let highCount = 0;
        let medCount = 0;

        for (const value of confidenceBreakdown) {

            if (value.confidence_level === 'UNKNOWN' || value.confidence_level === 'LOW') {
                lowCount = lowCount + value.count;
            }
            if (value.confidence_level === 'VHIGH' || value.confidence_level === 'HIGH') {
                highCount = highCount + value.count;

            }
            if (value.confidence_level === 'MED') {
                medCount = medCount + value.count;

            }

            confidenceBreakdown = [
                {
                    'confidence_level': 'LOW',
                    'count': lowCount
                },
                {
                    'confidence_level': 'HIGH',
                    'count': highCount
                },
                {
                    'confidence_level': 'MED',
                    'count': medCount
                }
            ];
        }

        return confidenceBreakdown;
    }

    private mapConfidenceLevel(item) {

        return {
            confidence_level: item.confidence_level,
            count: item.count
        };

    }

    mapIndividualVideoResultItem(item, parrotID) {
        // console.log(item);
        return {
            parrot_id: item.parrot_id,
            video_id: item.video_id,
            video_url_safe: this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + item.video_id),
            video_url: 'https://www.youtube.com/watch?v=' + item.video_id,
            latest_views: this.transformViews(item.latest_views),
            title: item.title ? item.title : 'N/A',
            truncated_title: item.title ? item.title.substr(0, 10) + '...' : 'N/A',
            description: item.description ? (item.description).replaceAll('\n', '<br>') : 'N/A',
            tags: item.tags ? this.transformTags(item.tags) : 'N/A',
            confidence_label: item.confidence_label,
            confidence_score: item.confidence_score,
            human_verified: item.human_verified ? item.human_verified : 'PENDING',
            // start_date = item.start_date ? new Date(item.start_date).toISOString().slice(0, 10) : '0000-00-00',
            added_time: item.added_time ? new Date(item.added_time).toISOString().slice(0, 10) : 'N/A',
            published_time: item.published_at_time ? this.transformDate(new Date(item.published_at_time)) : 'N/A'
        };
    }

    private transformTags(values) {
        let tagString = '';

        for (const value of values) {
            tagString = tagString + ' #' + value.replaceAll(' ', '') + ' ';
        }

        return tagString;
    }

    private transformViews(value) {
        let newValue = value;
        if (value >= 1000) {
            const suffixes = ['', 'K', 'M', 'B', 'T'];
            const suffixNum = Math.floor(('' + value).length / 3);
            let shortValue: any;
            for (let precision = 2; precision >= 1; precision--) {
                shortValue = parseFloat((suffixNum !== 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(precision));
                const dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '');
                if (dotLessShortValue.length <= 2) {
                    break;
                }
            }
            if (shortValue % 1 !== 0) {
                shortValue = shortValue.toFixed(1);
            }
            ;
            newValue = shortValue + suffixes [suffixNum];
        }
        return newValue;
    }

    private transformDate(date: Date) {
        return this.datePipe.transform(date, 'd MMM yyyy');
    }

    mapIndividualConfidenceBreakdown(item) {
        // console.log(item);
        return {
            confidence_level: item.confidence_level,
            total_count: item.count,
            total_approved: item.approved ? item.approved : 0,
            total_rejected: item.rejected ? item.rejected : 0,
            total_pending: item.pending ? item.pending : 0
        };
    }

    mapEsResultItem(item) {
        // console.log(item);

        return {
            parrotId: item._source.parrot_id,
            title: item._source.title,
            displayName: item._source.display_name ? item._source.display_name : item._source.title,
            catalogState: item._source.catalog_state ? item._source.catalog_state : '',
            releaseYear: item._source.data.release_year ? item._source.data.release_year : '',
            originalCountry: item._source.data.original_country ? item._source.data.original_country['1'] : '',
            originalNetwork: item._source.data.original_network ? item._source.data.original_network['1'] : '',
            originalLanguage: item._source.data.original_language ? item._source.data.original_language['1'] : '',
            genreTags: item._source.data.genre_tags ? item._source.data.genre_tags : [],
            totalSeasons: item._source.data.total_seasons ? item._source.data.total_seasons : null,
            totalEpisodes: item._source.data.total_episodes ? item._source.data.total_episodes : null,
            shortDescription: item._source.data.short_description,
            akas: item._source.data.also_known_as ? item._source.data.also_known_as : '',
            collapsed: false,
            checked: false,
            active: false,
            externalMappings: item._source.data.external_mappings ? item._source.data.external_mappings : null,
            priority: item._source.internal_data && item._source.internal_data.priority ? item._source.internal_data.priority.toLowerCase() : 'none'
        };
    }

    mapEsImdbResultItem(item) {
        return {
            title: item._source.Title,
            displayName: item._source.Title,
            catalogState: null,
            releaseYear: item._source.Year ? item._source.Year : '',
            originalCountry: item._source.Countries && item._source.Countries.Country ? item._source.Countries.Country[0] : '',
            originalNetwork: item._source.ProductionCompanies && item._source.ProductionCompanies.ProductionCompany ? item._source.ProductionCompanies.ProductionCompany[0] : '',
            shortDescription: item._source.PlotSummary ? item._source.PlotSummary : '',
            // tslint:disable-next-line:no-shadowed-variable
            akas: item._source.AKAs && item._source.AKAs.aka ? item._source.AKAs.AKA.map(item => item.title).join(', ') : '',
            collapsed: false,
            checked: false,
            active: false,
            imdb: true,
            imdbId: item._source.ResourceId,
            link: `https://www.imdb.com/${item._source.ResourceId.includes('tt') ? 'title' : 'name'}/${item._source.ResourceId}`
        };
    }

    getMappings(titleId: string, source: string, page: number) {
        const url = this.getBaseUrl() + this.DATAHEALTH_MAPPINGS_URL +
            `?titleId=${titleId}&source=${source}&page=${page}`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers: headers});
        return this.http.get(url)
            .map(res => res.json())
            .map(res => res.json())
            .toPromise();
    }

    putTitleNameChange(parrotId: string, title: string, newTitle: string) {
        const url = this.getBaseUrl() + this.TITLE_NAME_CHANGE_URL;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        const options = new RequestOptions({headers});
        const payload = [
            {
                'parrot_id': parrotId,
                'title': title,
                'gene': 'title',
                'value': newTitle
            }
        ];
        return this.http.put(url, JSON.stringify(payload), options)
            .map(res => res.json())
            .toPromise();
    }

    private convertLanguageCode(originalCountry) {

        try {
            const languages = require('@cospired/i18n-iso-languages');
            languages.registerLocale(require('@cospired/i18n-iso-languages/langs/en.json'));

            return languages.getName(originalCountry, 'en');
        } catch (ex) {
            // console.log(ex);
            return originalCountry.toUpperCase();
        }

    }


}



// WEBPACK FOOTER //
// ./src/app/bulkinfohash-v2/model/bulk-infohash-v2.service.ts